<template>
  <fixedTab></fixedTab>
  <router-view />
</template>

<script>
import fixedTab from "@/components/fixedTab.vue";
export default {
  name: 'App',
  components: {
    fixedTab
  }
}
</script>

<style lang="scss">
  @import "./style/reset.scss";
  @import "./style/base.scss";
  //放大镜位置
  .mouse-cover-canvas {
    position: absolute;
    top: 173px !important;
    left: 740px !important;
  }

  .el-switch.is-checked .el-switch__core {
    border-color: #255984 !important;
    background-color: #255984 !important;
}

// .el-cascader-menu {
//   .in-active-path,
//   .is-active {
//     .el-cascader-node__label {
//       color: $colorMain !important;
//     }
//   }
//   .el-icon-arrow-right {
//     color: $colorMain !important;
//   }
// }
</style>
